// @flow

import React from 'react';
import { WIZARD_DOMAIN } from '../util/config';

export const Footer = () => (
  <div>
    <hr />
    <footer style={{
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: '0.75rem',
      fontWeight: '400',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      lineHeight: '1.375em',
      textAlign: 'left',
      padding: '5px',
    }}>
      © Expedition Data {(new Date()).getFullYear()} |
      &nbsp;<a href={`${WIZARD_DOMAIN}/privacypolicy`} style={{ color: 'gray' }}>Privacy Policy</a>
    </footer>
  </div>
);
